// Opens the desktop "Shop" style dropdown/mega menus on mouse hover,
// in addition to the theme's default click-to-toggle behavior.
// Touch and non-hover-capable devices are left completely untouched,
// so mobile tap navigation keeps working exactly as before.
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var CLOSE_DELAY = 150;

  document.querySelectorAll('header-menu').forEach(function (menu) {
    var details = menu.querySelector(':scope > details');
    if (!details) return;

    var closeTimer = null;

    menu.addEventListener('mouseenter', function () {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      details.open = true;
    });

    menu.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        details.open = false;
        closeTimer = null;
      }, CLOSE_DELAY);
    });
  });
})();
